import {
  Link,
  useLoaderData,
} from "react-router-dom";
import { useState, useEffect } from "react";
import Select from "react-select";
import * as API from "../services/cita";

import * as APIPACIENTES from "../services/pacientes";


export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getCitaByID(params.citaId);
}


export function CitaItem(props) {
  const cita = useLoaderData();
  const errorMessage = cita?.message;

  const citaResp = cita.meta?.citaResp;
  const citaTipo = cita.meta?.citaTipo;
  const citaPac = cita.meta?.citaPac?.label;
  const citaFecha = cita.meta?.citaFecha;
  const citaHora = cita.meta?.citaHora;
  const citaFinFecha = cita.meta?.citaFinFecha;
  const citaFinHora = cita.meta?.citaFinHora;
  const citaObs = cita.meta?.citaObs;
  const citaEsp = cita.meta?.citaEsp;

  const citaDate = new Date(cita.date);
  const diffDate = (Math.abs(new Date() - citaDate) / 36e5);


  return (
    <>
    <div id="content">
      {cita?.length === 0 ? (
        <div>Cargando...</div>
      ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
      <form id="formUpdatelement">
        <fieldset id="disabledContainer" disabled="disabled">
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='citaEsp'>Responsable</label>
              {Array.isArray(citaEsp) && citaEsp.length !== 0 ? (
              <div className='control'>
                <Select
                  isMulti
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaEsp'
                  name='citaEsp'
                  required
                  value={citaEsp}
                  isDisabled={true}
                />
              </div>
              ) : (
              <div className='control'>
                <input
                  className='input'
                  id='citaEsp'
                  disabled
                  type='text'
                  value={citaResp}
                />
              </div>
              )}
            </div>
            
            <div className='field'>
              <label htmlFor='citaTipo'>Tipo</label>
              <div className='control'>
                <div className='select'>
                    <select
                      className='select'
                      id='citaTipo'
                      name='citaTipo'
                      value={citaTipo}
                      readOnly
                    >
                      <option disabled readOnly value=''>-- Selecciona una opción --</option>
                      <option readOnly value='ingreso'>Ingreso</option>
                      <option readOnly value='valoracion'>Valoracion</option>
                      <option readOnly value='refuerzo'>Refuerzo</option>
                      <option readOnly value='consulta-pre-tratamiento-medica'>Consulta Pre-Tratamiento Médica</option>
                      <option readOnly value='visita-medica'>Visita Médica</option>
                      <option readOnly value='consulta-post-tratamiento-medica'>Consulta Post-Tratamiento Médica</option>
                      <option readOnly value='consulta-pre-tratamiento-psicologica'>Consulta Pre-Tratamiento Psicológica</option>
                      <option readOnly value='visita-psicologica'>Visita Psicológica</option>
                      <option readOnly value='consulta-post-tratamiento-psicologica'>Consulta Post-Tratamiento Psicológica</option>
                      <option readOnly value='psicoterapia'>Sesión Psicoterapia</option>
                      <option readOnly value='nutricion'>Nutrición</option>
                      <option readOnly value='entrenamiento'>Entrenamiento</option>
                      <option readOnly value='mindfulness'>Mindfulness</option>
                      <option readOnly value='nota'>Nota</option>
                      <option readOnly value='who5'>Test Who5</option>
                      <option readOnly value='psqi'>Test PSQI</option>
                      <option readOnly value='scl90'>Test SCL90</option>
                    </select>
                </div>
              </div>
            </div>
          </div>

          {(citaTipo !== 'nota') &&

          <div className='field'>
            <label htmlFor='citaPac'>Paciente</label>
            <div className='control'>
              <input
                readOnly
                className='input'
                id='citaPac'
                type='text'
                value={citaPac}

              />
            </div>
          </div>

          }
        

        <div className='grid--2col'>

          <div className='field'>
              <label htmlFor='citaFecha'>Fecha Inicio</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFecha'
                  type='date'
                  value={citaFecha}
                  readOnly
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='citaHora'>Hora Inicio</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaHora'
                  type='time'
                  value={citaHora}
                  readOnly
                />
              </div>
            </div>

            {((citaTipo === 'ingreso') || (citaTipo === 'refuerzo')) &&
            <>
            <div className='field'>
              <label htmlFor='citaFinFecha'>Fecha Final</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFinFecha'
                  type='date'
                  value={citaFinFecha}
                  readOnly
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='citaFinHora'>Hora Final</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFinHora'
                  type='time'
                  value={citaFinHora}
                  readOnly
                />
              </div>
            </div>
            </>
            }
          </div>
          
          <div className='field'>
            <label htmlFor='citaObs'>Observaciones</label>
            <div className='control'>
              <textarea
                readOnly
                className='textarea'
                name='citaObs'
                id='citaObs'
                value={citaObs}
                
              ></textarea>
            </div>
          </div>

      </fieldset>
      </form>
      ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72) || (props.userRole.includes('administrador')))  &&
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      }
      </div>
      }
    </>
  );
}
